/* eslint-disable jsx-a11y/iframe-has-title */
import { useCallback, useEffect, useState } from "react"
import { useSelector, useDispatch } from 'react-redux';
import ContentLoader from 'react-content-loader'
import VideoPlayer from "react-video-js-player";
import CONFIG from "../../utils/config";
import { SessionKeys } from "../../utils/AppUtils";
// import ReactPDF from from 'react-pdf';
import _ from "lodash";
// import $ from "jquery";
// import FileViewer from "react-file-viewer";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Pdftron from "./Pdftron";
import { videoEvents } from "../../utils/VideoClickStream";
import { markModuleProgress } from "../../redux/courses/actions";
import useLogin from "../../custom-hooks/useLogin";
export const ModuleComp = (props) => {

    const {
        mId,
        courseId,
        fetchDataFromIframe,
        openFavourites,
        refer,
        moduleInfo,
        setIsLoad,
        isLoad,
        isModuleChange,
        reload,
        setIsLoading,
        purchasedInfo
    } = props;

    const {isLoggedIn} = useLogin();
    const [iframeHeight, setIframeHeight] = useState(600)
    const [iframeMinHeight, setIframeMinHeight] = useState(600);
    const dispatch = useDispatch()
    const moduleListingData = useSelector(state => {
        return state.courses.moduleListing
    });
    const moduleListingDataBroker = useSelector(state => state.courses.moduleListingBroker);
    const authBroker = useSelector(state => state.auth.authBroker)
    // const [selectedModule, setSelectedModule] = useState(history.location.state.module);
    const [moduleData, setModuleData] = useState({})
    const search = window.location.search;
    const params = new URLSearchParams(search);

    const c = params.get("c");
	let decodedString = atob(c);
	let paramsReq = JSON.parse(decodedString);
    const source = paramsReq.source;
    const via_lp = paramsReq.via_lp;
    const lp_id = paramsReq.lp_id;
    const via_cat = paramsReq.via_cat;
    const cat_id = paramsReq.catId;
    const level_id = paramsReq.level_id;
    const is_level = paramsReq.is_level;
    const cid = paramsReq.cid;
    const from = paramsReq.from;
    const lp_source = paramsReq.lp_source;

//     const source = params.get('source');
    
//   const cid = params.get("cid");
//   const via_lp = params.get('via_lp');
//   const lp_id = params.get('lp_id');
//   const via_cat = params.get('via_cat');
//   const cat_id = params.get('cat_id');
//   const level_id = params.get('level_id');
//   const is_level = params.get('is_level');
//   const from = params.get('from')
//   const lp_source = params.get("lp_source");

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [moduleDataInfo, setModuleDataInfo] = useState({})
    const [scormURL, setScormURL] = useState('')

    useEffect(() => {
        console.log("m-info",moduleInfo)
        // alert(JSON.stringify(purchasedInfo))
        if (!_.isEmpty(moduleInfo)) {
            setModuleDataInfo(moduleInfo)
            if (source === 'broker' || !_.isEmpty(purchasedInfo)) {
                let sURL = "";
                if (source === 'xsel' || source === 'ecom') {
                    sURL = `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`
                    if (_.toNumber(lp_id) && (from==="lp" || via_lp==="true")) {
                        sURL = sURL + `&lp_id=${lp_id}`
                    }
                    if(purchasedInfo?.is_purchased){
                        sURL = sURL + `&isPaid=true`
                    }else{
                        sURL = sURL + `&isPaid=false`
                    }
                    
                    if(purchasedInfo?.selling_price === 0){
                        sURL = sURL + `&isFree=true`
                    }else{
                        sURL = sURL + `&isFree=false`
                    }
                        
                } else {
                    sURL = `${CONFIG.SCORM_URL_BROKER}?course_id=${courseId}&module_id=${mId}&output=embed`
                    if (_.toNumber(lp_id) && (from === "lp" || via_lp==="true")) {
                        sURL = sURL + `&lp_id=${lp_id}`
                    }
                }
                if (isLoggedIn) {
                    let userId = localStorage.getItem('USER_ID');
                    let email = authBroker?.payload?.user?.email
                    sURL= sURL + `&email=${email}&user_id=${userId}`
                    setScormURL(sURL)
                } else {
                    setScormURL(sURL)
                }
                console.log('SCORM URL', sURL)
            }
        }
    }, [moduleInfo, authBroker, isLoggedIn, purchasedInfo])

    // const moduleCallBack = useCallback(() => {
    //     if (!_.isEmpty(moduleInfo)) {
    //         setModuleDataInfo(moduleInfo)
    //     }
    // }, [moduleInfo])

    useEffect(() => {
        console.log('SCORM IURL ', scormURL)
    }, [scormURL])

    useEffect(() => {
        if (isLoad) {
            console.log('reset height')
            setIframeHeight(600)
        }
    }, [isLoad])

    useEffect(() => {
        if (isModuleChange) {
            setModuleDataInfo({})
        }
    }, [isModuleChange])

    useEffect(() => {
        if (!_.isEmpty(moduleListingData)) {
            setIframeHeight(600)
        }
    }, [moduleListingData])

    useEffect(() => {
        if (iframeHeight < iframeMinHeight) {
            setIframeMinHeight(iframeHeight)
        }
    }, [iframeHeight])

    useEffect(() => {
        if (!_.isEmpty(moduleInfo)) {
            window.addEventListener("message", handleNotes)
            window.addEventListener("message", favourites)
            window.addEventListener("message", scrollToSection)
            window.addEventListener("message", heightChange)
        }

        return () => {
            window.removeEventListener("message", handleNotes)
            window.removeEventListener("message", favourites)
            window.removeEventListener("message", heightChange)
            window.removeEventListener("message", scrollToSection)
        }
    }, [moduleInfo])

    useEffect(() => {
        console.log('MODULE COMP')
    },[])

    const handleNotes = evt => {
        console.log('event', evt)
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        if (dataObj && dataObj.method === 'notes') {
            console.log('NOTES CLICKED', dataObj, evt)
            dataObj.url = evt.origin;
            fetchDataFromIframe(dataObj);
        }

    }

    const heightChange = evt => {
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        if (dataObj && dataObj.method === 'heightChange') {
            // console.log('heightChange: ', dataObj)
            if (dataObj.height > iframeMinHeight) {
                setIframeHeight(dataObj.height)
            }
            if (dataObj.scrollTop) {
                window.scrollTo(0,0)
            }
        }
    }

    const favourites = evt => {
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        // console.log("Favourites method data---->", dataObj)
        if (dataObj && dataObj.method === 'favourites') {
            openFavourites(dataObj);
            // console.log("open favvv",openFavourites)
            // window.captureMyEvents("favouriteAdded", {
            //   mid: currentModule.module_id,
            //   sid: dataObj.sectionId,
            // });       
        }

    }

    const scrollToSection = (evt) => {
        // console.log('eventScroll', evt)
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        // console.log(dataObj.method);
        if (dataObj && dataObj.method === 'contentScrollTo') {
            // console.log('scroll to', dataObj)
            window.scrollTo({
                top: dataObj.topPosition + document.getElementById("scorm_player").offsetTop / 2,
                behavior: 'smooth'
            })
        }
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const setLoadFalse = () => {
        setTimeout(() => {
            setIsLoad(false)
        }, 500)
    }

    const markProgress = () => {
        return;
    }

    const onPlayerReady = (player) => {
        // console.log("Player is ready: ", player);
        // splayer;
        const trackEl = player.addRemoteTextTrack(
            {
                // src: 'https://rsplearning-dev.niit-mts.com/public/leadersedgetraining_advertising_and_privacy.webvtt',
                kind: "captions",
                srclang: "en",
                label: "English"
            },
            false
        );
        trackEl.addEventListener('load', function () {
            // your callback goes here
        });
        if(_.toInteger(moduleInfo?.progress) < 100)
        {
        // player.controlBar.progressControl.hide();
        }
        videoEvents(player, {
            type: 'module',
            course_id: courseId,
            module_id: mId,
            user_id: authBroker?.payload?.user?.user_id
        })

        player.on('ended', () => {
            if (isLoggedIn) {
                setIsLoading(true)

                let reqBody = {
                    module_id: mId,
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    course_id: courseId,
                  }
                  console.log("is_purchased in modulecomp",purchasedInfo)
                //   if(purchasedInfo) {
                //     reqBody.course_id = courseId;
                //   }
              
                  if(from==="lp"){
                    reqBody.lp_id = lp_id;
                  }
              
                dispatch(
                    markModuleProgress({
                        module: "markModuleProgress",
                        postData: reqBody,
                    })
                );

                player.one('play', function() {
                    console.log("User clicked replay. Showing progress bar...");
                    player.controlBar.progressControl.show();
                });
            }
        })
    }
    
    return (
        <div className="row mb-2" aria-hidden="false">
            {(isLoad) ?
                <div className="pt-5 loader-launch">
                    {[...Array(4)].map((el, index) => <ContentLoader key={index} className="pt-2 w-100" />)}
                </div> 
            : null}
            {
                !_.isEmpty(moduleDataInfo) && 
                (source === 'xsel' || source === 'ecom')
                && reload
                ?
                    (<iframe
                        key={mId}
                        type="text/html"
                        className="w-1000"
                        id="scorm_player"
                        height={iframeHeight}
                        style={{ minHeight: iframeMinHeight, width: "70%", margin: "0 auto" }}
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); }}
                        ref={refer}
                        // src="https://jba-learn-dev.niit-mts.com/scorm_player.php?course_id=jbc_hr_od&module_id=jbc_hr_od_m1"
                        // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657078/launch.html?crscd=CSCD_58"
                        // src={`https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=${courseId}&module_id=${mId}&username=${username}`}
                        // src={
                        //     `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&user_id=${authBroker?.payload?.user?.user_id}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`}
                        // src="https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=CSCD_72&module_id=624ed8bc5cf45c05dd4bf234"
                        // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657162/index.html"
                        src={scormURL}
                        allowFullScreen={true}
                    />)
                :
                    !_.isEmpty(moduleDataInfo) && reload ?
                    (moduleDataInfo?.rsp_scromdata.map((module) => {
                        if (module.type.toLowerCase() === "url") {
                            return (
                                <iframe
                                    key={mId}
                                    type="text/html"
                                    className="w-100"
                                    id="scorm_player"
                                    height={iframeHeight}
                                    style={{ minHeight: iframeMinHeight, width: "70%", margin: "0 auto" }}
                                    frameBorder="0"
                                    marginHeight="0"
                                    marginWidth="0"
                                    onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                    ref={refer}
                                    // src="https://jba-learn-dev.niit-mts.com/scorm_player.php?course_id=jbc_hr_od&module_id=jbc_hr_od_m1"
                                    // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657078/launch.html?crscd=CSCD_58"
                                    // src={`https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=${courseId}&module_id=${mId}&username=${username}`}
                                    // src={source === 'broker' ?
                                    //     `${CONFIG.SCORM_URL_BROKER}?course_id=${courseId}&module_id=${mId}&email=${authBroker?.payload?.user?.email}&user_id=${authBroker?.payload?.user?.user_id}&output=embed` :
                                    //     `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&user_id=${authBroker?.payload?.user?.user_id}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`}
                                    // src="https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=CSCD_72&module_id=624ed8bc5cf45c05dd4bf234"
                                    // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657162/index.html"
                                    src={scormURL}
                                    allowFullScreen={true}
                                />
                            )
                        } else if (module.type.toLowerCase() === "mp4" || module.type.toLowerCase() === "mov") {
                            setLoadFalse(true)
                            // console.log("it reached mp4")
                            return (
                                <>
                                    {isLoad
                                        ? <></> :
                                        <div className="container">
                                            <div className="row" >
                                                <div className="col-md-12" >
                                                    <div className="video-fullbox">
                                                        <div className="search__input">
                                                            <div className="img-box_RP">
                                                                <div className="video-full">

                                                                    <VideoPlayer
                                                                        className="img-videosec learn_image-card"
                                                                        controls={true}
                                                                        // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                                                        src={module.url}
                                                                        width="720"
                                                                        height="420"
                                                                        autoPictureInPicture={true}
                                                                        // poster={module.}
                                                                        // onLoad={setLoadFalse}
                                                                        fluid={true}
                                                                        inline={false}
                                                                        pictureInPictureToggle={true}
                                                                        type={module.type.toLowerCase() === "mp4" ? "video/mp4" : "video/mov"}
                                                                        onReady={onPlayerReady}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            )
                        } else if (module.type === "pdf") {
                            return (

                                <div className="pdf-view-page" style={{ height: "1200px" }}>

                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={CONFIG.API_URL_BROKER_ADMIN + "/pdfview/?id=" + mId + "&u_token=" + localStorage.getItem(SessionKeys.API_TOKEN_BROKER)} title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "xlsx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "docx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "pptx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else {
                            <div className="container">
                                <div className="row" >
                                    <div className="col-md-12" >
                                        <div className="video-fullbox">
                                            <div className="search__input">
                                                <div className="img-box_RP">
                                                    <div className="video-full">
                                                        <VideoPlayer
                                                            className="img-videosec learn_image-card"
                                                            controls={true}
                                                            // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                                            src={module.url}
                                                            width="720"
                                                            height="420"
                                                            autoPictureInPicture={true}
                                                            // poster={module.}
                                                            // onLoad={setLoadFalse}
                                                            fluid={true}
                                                            inline={false}
                                                            pictureInPictureToggle={true}
                                                            onReady={onPlayerReady}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                    ) : ''
            }
        </div>
    )
}